import React from "react";
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";

type Props = {
  isOpen: boolean;
  handleOriginal: any;
  handleDuplicate: any;
  actions?: { label: string; onClick: () => void }[];
  children?: any;
  heading?: string;
  headerColor?: string;
  onClose?: any;
  contentClassName?: string;
  paperClassName?: string;
};
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});
export default function DuplicateReceiptDialog({
  isOpen,
  handleOriginal,
  handleDuplicate,
  actions,
  children,
  heading,
  headerColor = "",
  onClose,
  contentClassName,
  paperClassName,
}: Props): React.ReactElement {
  return (
    <>
      <Dialog
        className="dialog"
        style={{ borderRadius: 1 }}
        open={isOpen}
        onClose={onClose}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{ className: paperClassName }}
      >
        <Typography>
          <DialogTitle
            id="alert-dialog-slide-title"
            style={{ color: headerColor ? headerColor : "inherit" }}
          >
            {heading}
          </DialogTitle>
        </Typography>
        <DialogContent className={contentClassName} style={{ fontSize: 16 }}>
          {children}
        </DialogContent>
        <DialogActions style={{ marginRight: 10, marginBottom: 5 }}>
          {actions?.length ? (
            actions.map((a, idx) => (
              <Button key={`${a.label}-${idx}`} onClick={a.onClick} variant="contained">
                {a.label}
              </Button>
            ))
          ) : (
            <>
              <Button onClick={handleOriginal} variant="contained">
                Original
              </Button>
              <Button onClick={handleDuplicate} variant="contained">
                Duplicate
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
